export const SET_COMMANDE_A_FACTURER = 'SET_COMMANDE_A_FACTURER';
export const SET_TOTAL_COMMANDE_A_FACTURER = 'SET_TOTAL_COMMANDE_A_FACTURER';
export const SET_CRITERES_RECHERCHE = 'SET_CRITERES_RECHERCHE';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
